//interceptor network (not used cause blocker in unitest)

/* eslint-disable no-param-reassign */
import Axios from 'axios';
import { URL_API_GATEWAY } from '../config/keys';
import { requestRefreshToken } from '../data/auth';
import { deleteLocalUser, getRefreshToken, getToken } from '../utils/localStorage';

const gatewayHttpService = Axios.create({
  baseURL: URL_API_GATEWAY,
  timeout: 20000,
  headers: {
    'content-type': 'application/json',
    refreshToken: '',
  },
});

gatewayHttpService.interceptors.request.use(
  // custom handle config
  (config) => {
    const token = getToken() ? `Bearer ${getToken()}` : null;
    const refreshToken = config.headers?.refreshToken;
    return {
      ...config,
      headers: {
        'content-type': 'application/json',
        ...(token && {
          Authorization: refreshToken || token,
        }),
      },
    };
  },
  (error) => Promise.reject(error),
);

gatewayHttpService.interceptors.response.use(
  // custom handle response success
  async (res) => res.data,
  // custom handle response error
  async (error) => {
    if (error?.response) {
      const { status, data } = error.response;
      if (status === 401) {
        if (data.message === 'UNAUTHORIZED' && data.data.message === 'invalid token') {
          deleteLocalUser();

          return (window.location.href = '/login');
        }

        const refreshToken = `Bearer ${getRefreshToken()}`;

        await requestRefreshToken(refreshToken);

        return window.location.reload();
      }
    }

    return Promise.reject(error);
  },
);

export default gatewayHttpService;
